// extracted by mini-css-extract-plugin
export default {"integrationIcon":"integrationSetupHeader_integrationIcon__ErUPF","integrationContent":"integrationSetupHeader_integrationContent__nh4pU"};